import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { Button, Icon, Loader, Pagination, Popup } from "semantic-ui-react";
import WikiCard from "../../components/layout/WikiCard";
import AddWiki from "../AddWiki";
import { getFilteredEvents } from "../../utils/utils";
import WikiFilter from "../../components/layout/WikiFilter";
import "../SuperWiki.css";
const Events = (props) => {
  const [totalPages, setTotalPages] = useState(1);
  const [activePage, setActivePage] = useState(1);
  const [data, setData] = useState([]);
  const [addEvent, setAddEvent] = useState(false);
  const [search, setSearch] = useState(null);
  const [athletesWiki, setAthletesWiki] = useState(false);

  useEffect(() => {
    let todaysData = [];
    if (athletesWiki) {
      if (props.athletesWiki) {
        todaysData = [...props.athletesWiki];
      }
    } else {
      if (props.wikis) {
        todaysData = [...props.wikis];
      }
    }

    const paginated =
      todaysData && todaysData.slice((activePage - 1) * 8, activePage * 8);
    setTotalPages(Math.ceil(todaysData.length / 8));
    setData(paginated);
  }, [props.athletesWiki, athletesWiki, props.wikis, activePage]);
  const handleSearch = (query) => {
    setSearch(query);
    // setActivePage(1);
  };
  const handleAddEventClose = () => {
    setAddEvent(false);
  };

  if (!props.auth.isLoaded) {
    return (
      <div className="SpinnerBackground">
        <div className="SpinnerContainer">
          <Loader size="large" active inline="centered" />
        </div>
      </div>
    );
  } else if (props.auth.isLoaded) {
    if (data) {
      const pageChange = (not, data) => {
        setActivePage(data.activePage);
      };
      return (
        <div className="AthleteDetailsBackground cu-profile wiki-section">
          <div className="AthleteDetailsBannerBar"></div>

          <WikiFilter
            onChange={() => setActivePage(1)}
            superAdmin={true}
            searchQuery={handleSearch}
          />
          <div className="AthleteDetailsButtonContainer event-header">
            <div className="first-div">
              <Popup
                content={
                  athletesWiki
                    ? "Click to See Advocates' Wikis"
                    : "Click to See Athletes' Wikis"
                }
                trigger={
                  <Button
                    color="blue"
                    content={
                      !athletesWiki ? "Advocates' Wikis" : "Athletes' Wikis"
                    }
                    onClick={() => {
                      setAthletesWiki(!athletesWiki);
                      setActivePage(1);
                    }}
                  />
                }
              />
            </div>
            <div className="second-div"></div>
          </div>
          <div className="AthleteEventsInfoContainer common-event">
            <>
              <div
                className={`AthleteEventsGroupContainer EventListView with-profile ${
                  data && (data.length < 2 ? "onlyone" : "")
                }`}
              >
                {data && data.length > 0 ? (
                  data.map((wiki) => (
                    <>
                      <WikiCard key={wiki.id} wiki={wiki} profile />
                    </>
                  ))
                ) : (
                  <p className="not-found cu-center">
                    There's No Data Right Now
                  </p>
                )}
              </div>
            </>
          </div>
          {/* pagination and pages show */}
          <div className="AthleteSearchDetail AthletePagination justify-center">
            <Pagination
              onPageChange={pageChange}
              activePage={activePage}
              firstItem={null}
              lastItem={null}
              prevItem={{ content: <Icon name="angle left" />, icon: true }}
              nextItem={{
                content: <Icon name="angle right" />,
                icon: true,
              }}
              pointing
              secondary
              totalPages={totalPages}
            />
          </div>

          {/* AddWiki */}
          <AddWiki
            open={addEvent}
            role={props.role && props.role}
            close={handleAddEventClose}
            fromAdvocate={props.advocateId}
          />
        </div>
      );
    } else
      return (
        <div className="SpinnerBackground">
          <div className="SpinnerContainer">
            <Loader size="large" active inline="centered" />
          </div>
        </div>
      );
  } else if (props.auth.isLoaded && !props.auth.email) {
    return <Redirect to={`/login`} />;
  } else if (props.auth.isLoaded && props.auth.email) {
    return <Redirect to={`/events`} />;
  }
  return null;
};

const mapStateToProps = (state) => {
  const wikiData = state.firestore.ordered.wiki;
  const advocateWiki = state.firestore.data.wikiAdvocates;
  const athletesWiki = state.firestore.data.wikiAthletes;

  let advocateWikiOrder = [];
  let athletesWikiOrder = [];

  if (
    wikiData &&
    wikiData.length > 0 &&
    advocateWiki &&
    Object.keys(advocateWiki).length > 0 &&
    advocateWiki.order &&
    Object.keys(advocateWiki.order).length > 0 &&
    athletesWiki &&
    Object.keys(athletesWiki).length > 0 &&
    athletesWiki.order &&
    Object.keys(athletesWiki.order).length > 0
  ) {
    advocateWikiOrder = [...advocateWiki.order.wikis];
    athletesWikiOrder = [...athletesWiki.order.wikis];

    advocateWikiOrder = advocateWikiOrder.map((id) => {
      let data = null;
      wikiData.forEach((ele) => {
        if (ele.id === id) {
          data = ele;
        }
      });
      return data;
    });
    athletesWikiOrder = athletesWikiOrder.map((id) => {
      let data = null;
      wikiData.forEach((ele) => {
        if (ele.id === id) {
          data = ele;
        }
      });
      return data;
    });
  }
  return {
    wikis: advocateWikiOrder,
    athletesWiki: athletesWikiOrder,
    auth: state.firebase.auth,
    superAdmin: state.auth.superAdmin,
    sport: state.athlete.superSport,
    date: state.athlete.superDate,
    creator: state.athlete.superCreator,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {
    const firestoreArray = [
      getFilteredEvents(
        props.sport,
        props.creator,
        props.date,
        props.superAdmin
      ),
      {
        collection: "advocates",
      },
      {
        collection: "wikiAdvocates",
      },
      {
        collection: "wiki",
      },
      {
        collection: "wikiAthletes",
      },
    ];
    return firestoreArray;
  })
)(Events);
